import React, { createContext, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showSuccessToast } from '../helpers/SweetAlert';
import { loginStateReset } from '../redux/slices/auth/LoginSlice';
import { logoutStateReset } from '../redux/slices/auth/LogoutSlice';
import { GetProfileApi } from '../redux/actions/profile/GetProfileAction';
// import { logoutStateReset } from '../redux/slices/Auth/LogoutSlice';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const dispatch = useDispatch();

    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        const token = localStorage.getItem('authToken');
        return token ? true : false;
    });

    const login = (token) => {
        localStorage.setItem('authToken', token);
        setIsAuthenticated(true);
    };

    const logout = () => {
        localStorage.removeItem('authToken');
        setIsAuthenticated(false);
        showSuccessToast('Logged out successful!');
        dispatch(logoutStateReset());
        dispatch(loginStateReset());
    };

    const fetchProfile = async () => {
        try {
            await dispatch(GetProfileApi());
        } catch (error) {
            console.error("Failed to fetch profile:", error);
        }
    };

    // const fetchDashboardData = async () => {
    //     try {
    //         await dispatch(GetUsersDataAPI());
    //         await dispatch(OrdersForSuppliersAPI());
    //         await dispatch(SuppliersOrdersAPI());
    //         await dispatch(GetUsersCountAPI());
    //     } catch (error) {
    //         console.error("Failed to fetch dashboard data:", error);
    //     }
    // }

    // const fetchCartProducts = async () => {
    //     try {
    //         await dispatch(GetProductsAddedToCartApi())
    //     } catch (error) {

    //     }
    // }

    useEffect(() => {
        if (isAuthenticated) {
            fetchProfile();
        }
    }, [isAuthenticated]);

    useEffect(() => {
        const checkAuth = () => {
            const token = localStorage.getItem('authToken');
            if (token) {
                setIsAuthenticated(true)
            } else {
                setIsAuthenticated(false)
            }
        };
        checkAuth();
    }, []);

    return (
        <AuthContext.Provider value={{ isAuthenticated, login, logout, fetchProfile }}>
            {children}
        </AuthContext.Provider>
    );
};
